import styled from 'styled-components';
import brandingColors from '../../colors/colors.js';
import { typography } from '../../typography/typography.js';

var LegendWrapper = /*#__PURE__*/styled.legend.withConfig({
  displayName: "styledComponents__LegendWrapper",
  componentId: "sc-143ilfq-0"
})(["display:block;line-height:", ";color:", ";border-width:0px;margin-bottom:5px;font-family:", ";font-size:", ";font-weight:600;text-align:left;width:auto;", ""], typography.lineHeight, brandingColors.light_1_dark_navy, typography.fontFamily, typography.fontSize, function (_ref) {
  var legendStyle = _ref.legendStyle;
  return legendStyle;
});
process.env.NODE_ENV !== "production" ? LegendWrapper.displayName = 'LegendWrapper' : void 0;

export default LegendWrapper;
export { LegendWrapper };
